import type { TenantAdmin } from '@wf-coe/types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/** Wire-format tenant admin — `grantedAt` is an ISO string. */
export type TenantAdminDto = Omit<TenantAdmin, 'grantedAt'> & {
  grantedAt: string;
};

/** Lists per-tenant admin assignments. Disabled until api + clientId both available. */
export function useTenantAdminsQuery(
  clientId: string | undefined,
): UseQueryResult<TenantAdminDto[]> {
  const api = useApiClient();
  return useQuery({
    queryKey: ['tenant-admins', clientId],
    queryFn: () => {
      if (!api) throw new Error('useTenantAdminsQuery: api client unavailable');
      if (!clientId) throw new Error('useTenantAdminsQuery: clientId required');
      return api.get<TenantAdminDto[]>(`/v1/clients/${clientId}/admins`);
    },
    enabled: api !== undefined && clientId !== undefined,
  });
}
